import React, { useEffect } from "react";
import { Tabs } from "react-vant";
import style from "./style.less";

const TabsData = [
  {
    title: "Originals",
    image: require("@/assets/images/home/class_icon/icon_Center.png").default,
    active_image: require("@/assets/images/home/class_icon/icon_Center2.png").default,
  },
  // {
  //   title: "Originals",
  //   image: require("@/assets/images/home/class_icon/icon_originsals.png").default,
  //   active_image: require("@/assets/images/home/class_icon/icon_originsals2.png").default,
  // },
  {
    title: "Popular",
    image: require("@/assets/images/home/class_icon/icon_popular.png").default,
    active_image: require("@/assets/images/home/class_icon/icon_popular2.png").default,
  },
  {
    title: "Spin",
    image: require("@/assets/images/home/class_icon/icon_spin.png").default,
    active_image: require("@/assets/images/home/class_icon/icon_spin2.png").default,
  },
  {
    title: "Slots",
    image: require("@/assets/images/home/class_icon/icon_slots.png").default,
    active_image: require("@/assets/images/home/class_icon/icon_slots2.png").default,
  },
  {
    title: "Football",
    image: require("@/assets/images/home/class_icon/icon_football.png").default,
    active_image: require("@/assets/images/home/class_icon/icon_football2.png").default,
  },
  {
    title: "Table Games",
    image: require("@/assets/images/home/class_icon/icon_tableGames.png").default,
    active_image: require("@/assets/images/home/class_icon/icon_tableGames2.png").default,
  },
  {
    title: "Instant Games",
    image: require("@/assets/images/home/class_icon/icon_instantGames.png").default,
    active_image: require("@/assets/images/home/class_icon/icon_instantGames2.png").default,
  },
];

const HomeGameTabNav = ({ onTabChange }) => {
  const [gameNavInfo, setGameNavInfo] = React.useState({});

  const [activeIndex, setActiveIndex] = React.useState(0);
  useEffect(() => {
    setGameNavInfo(gameNavInit);
  }, []);
  console.log("gameNavInfo", gameNavInfo);
  const gameNavInit = {
    0: {
      img: require("@/assets/images/home/class_icon/icon_originsals.png").default,
      name: "Originals",
      span_width: "50px",
    },
  };

  const onTabScrool = (tag, index) => {
    console.log(tag, index);
    setActiveIndex(index);
    if (typeof onTabChange == "function") {
      onTabChange(index);
    }
  };

  return (
    // <ul class={style.tab_container}>
    //     {gameNavInfo ? gameNavInfo.map((value, index) => (
    //         <li onClick={() => onTabClick(index)}>
    //             <img src={value.img} style={{ height: "1.1rem", marginRight: "0.3rem" }}/>
    //             <div class={style.tab_normal} >
    //                 <span style={{width: value.span_width}} >{value.name}</span>
    //             </div>
    //         </li>
    //     )): ""}
    // </ul>
    <div class={style.tab_container}>
      <Tabs
        type="capsule"
        style={{
          "--rv-tabs-default-color": "#ffffff",
        }}
        animated={true}
        // navBottom={<div class={style.tabBlock} active={active} />}
        onChange={onTabScrool}
      >
        {TabsData.map((tabData, index) => {
          return (
            <Tabs.TabPane
              key={tabData.title}
              style={{
                "--rv-tabs-line-height": "3.1rem",
              }}
              title={
                <div class={`${style.tab_normal}  ${index == activeIndex ? style.active_image : style.image}`}>
                  <img src={index == activeIndex ? tabData.active_image : tabData.image} />
                  <span>{tabData.title}</span>
                </div>
              }
            />
          );
        })}
      </Tabs>
    </div>
  );
};

export default HomeGameTabNav;
